<nav *ngIf="totalPageCount > 1" aria-label="paginator">
  <ul class="pagination justify-content-center">

    <li class="page-item"><a class="page-link" (click)="go(this.currentPage - 1)"
        [ngClass]="{disabled: currentPage === 1}"><i class="fa fa-angle-double-left"></i></a></li>
    
    <li class="page-item" [ngClass]="{active: (currentPage === 1)}"><a class="page-link" (click)="go(1)">1</a></li>
    
    <li class="page-item"><a class="page-link" *ngIf="isNavigatePreviousChunkVisible()"
        (click)="navigatePreviousChunk()">...</a></li>
    
    <li class="page-item" *ngFor="let page of visiblePages" [ngClass]="{active: (currentPage === page)}">
      <a class="page-link" (click)="go(page)">{{page}}</a>
    </li>

    <li class="page-item"><a class="page-link" *ngIf="isNavigateNextChunkVisible()"
        (click)="navigateNextChunk()">...</a></li>
    
    <li class="page-item" [ngClass]="{active: (currentPage === totalPageCount)}"><a class="page-link" (click)="go(totalPageCount)">{{totalPageCount}}</a></li>
    
    <li class="page-item"><a class="page-link" (click)="go(this.currentPage + 1)"
      [ngClass]="{disabled: currentPage === totalPageCount}"><i class="fa fa-angle-double-right"></i></a></li>
  </ul>
</nav>